/* This example requires Tailwind CSS v2.0+ */
import { FC } from "react";
import { PlusIcon } from "@heroicons/react/20/solid";
import { Link } from "components/Link";
import PrimaryButton from "components/buttons/PrimaryButton";
import { SeparatorIcon } from "./icons/SeparatorIcon";
import { FacilityIcon } from "./icons/FacilityIcon";
import { UppdragIcon } from "./icons/UppdragIcon";
import { UppgiftIcon } from "./icons/UppgiftIcon";
import { CustomerIcon } from "./icons/CustomerIcon";
import { TruckIcon } from "./icons/TruckIcon";
import { cn } from "helpers/classNames";
interface Props {
  header: string;
  className?: string;
  onClick?: () => void;
  subHeader: string;
  buttonText?: string;
  iconType?:
    | "separator"
    | "facility"
    | "customer"
    | "uppdrag"
    | "uppgift"
    | "truck";
}

const iconClassName = "h-8 w-8";

const EmptyState: FC<Props> = ({
  header,
  subHeader,
  buttonText,
  onClick,
  iconType,
  className,
}) => (
  <div
    className={cn(
      "sm:bg-inherit mx-auto my-auto flex h-full max-w-md flex-col items-center justify-center bg-white sm:py-0",
      className,
    )}
  >
    <div className="mx-auto my-auto flex flex-col items-center text-center">
      {iconType === "separator" && <SeparatorIcon className={iconClassName} />}
      {iconType === "facility" && <FacilityIcon className={iconClassName} />}
      {iconType === "uppdrag" && <UppdragIcon className={iconClassName} />}
      {iconType === "uppgift" && <UppgiftIcon className={iconClassName} />}
      {iconType === "customer" && <CustomerIcon className={iconClassName} />}
      {iconType === "truck" && <TruckIcon className={iconClassName} />}
      <h3 className="mt-2 text-sm font-medium text-gray-900">{header}</h3>
      <p className="mt-1 text-sm text-gray-500">{subHeader}</p>
      <div className="mt-6">
        {!!onClick && (
          <PrimaryButton size="small" onClick={onClick}>
            <PlusIcon className="-ml-1 mr-2 h-4 w-4" aria-hidden="true" />
            {buttonText}
          </PrimaryButton>
        )}
      </div>
    </div>
  </div>
);

export default EmptyState;
